function trigger_callback(elem, response) {
  var function_name = elem.data('callback');
  var fn = window[function_name];
  if (typeof fn === 'function') {
    window[function_name](response);
  }
}

function getGameFinderQueryStringValue(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

window.gtag = function() { dataLayer.push(arguments); }

var current_vertical = "";

function trigger_window_resize() {

  if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
   var evt = document.createEvent('UIEvents');
   evt.initUIEvent('resize', true, false, window, 0);
   window.dispatchEvent(evt);
  } else {
     window.dispatchEvent(new Event('resize'));

  }
}

jQuery(document).on("click", ".overlay-close-icon", function(){
  if(_element){
    _element.prependTo(_parent);
  }
  jQuery(".StandAloneVideoPlayer").removeClass("theater-mode");
  jQuery(".card").removeClass("theater-mode");
  jQuery(".vjs-theater-mode-control-close").addClass("vjs-theater-mode-control-open");
  jQuery(".vjs-theater-mode-control-close").removeClass("vjs-theater-mode-control-close");
  jQuery("body").css("overflow", "visible");
});

jQuery(document).on("click", ".destroy-overlay-icon", function(){
  jQuery(".StandAloneVideoPlayer").remove();
  jQuery(".card").removeClass("theater-mode");
  jQuery(".vjs-theater-mode-control-close").addClass("vjs-theater-mode-control-open");
  jQuery(".vjs-theater-mode-control-close").removeClass("vjs-theater-mode-control-close");
  jQuery("body").css("overflow", "visible");
});

function add_menu_active_class_to_body() {
  if (jQuery('#main-menu > .nav-item').hasClass('current-menu-item') || jQuery('#main-menu > .nav-item').hasClass('current-menu-ancestor')) {
    jQuery('body').addClass('menu-is-active');
  } else if (jQuery('#main-menu > li > ul.dropdown-menu > .nav-item').hasClass('current-menu-item')) {
    jQuery('#main-menu > li > ul.dropdown-menu > .nav-item.current-menu-item').parents('li.nav-item').addClass('current-menu-ancestor current-menu-parent');
    jQuery('body').addClass('menu-is-active');
  }

  if (jQuery('#main-menu > .nav-item').hasClass('current-menu-item')) {
    current_vertical = jQuery.trim(jQuery('#main-menu > .nav-item.current-menu-item > a').text());
  } else if (jQuery('#main-menu > .nav-item').hasClass('current-menu-ancestor')) {
    current_vertical = jQuery.trim(jQuery('#main-menu > .nav-item.current-menu-ancestor > a').text());
  }
}

add_menu_active_class_to_body();  

jQuery(".mobile-fullscreen-map-button").on("click", function() {
  jQuery(".mapplic-fullscreen-button").trigger("click");
});

window.initTourSlider = function() {

  if (typeof tour_slider !== 'undefined') {
    tour_slider.slick({
        centerMode: false,
        infinite: true,
        dots: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1200,
        autoplaySpeed: 6000,
        pauseOnHover: true,
        autoplay: true,
        appendArrows: 'footer',
        prevArrow: '<a href="##" class="slick-prev hidden-xs"></a>',
        nextArrow: '<a href="##" class="slick-next hidden-xs"></a>',
        slide: ".slick-carousel-item",
    });
  }
  
}

window.initMapTourSlider = function() {

  if (typeof map_tour_slider !== 'undefined') {
    map_tour_slider.slick({
        centerMode: false,
        infinite: true,
        dots: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1200,
        autoplaySpeed: 6000,
        pauseOnHover: true,
        autoplay: true,
        appendArrows: 'footer',
        prevArrow: '<a href="##" class="slick-prev hidden-xs"></a>',
        nextArrow: '<a href="##" class="slick-next hidden-xs"></a>',
        slide: ".slick-carousel-item",
    });
  }

}

jQuery(document).ready(function($){

  if($('iframe#tax').length > 0)
  {
    window.addEventListener('message', function(event) {
      if (event.origin.indexOf("winstarforms.com") == -1)
        return;

      if (event.data.hasOwnProperty('iFrameHeight')) {
        $('iframe#tax').height(event.data.iFrameHeight);
      }
    }, false);
  }

  if(is_mobile_device){
    if(getGameFinderQueryStringValue('post_type').length > 0 && getGameFinderQueryStringValue('post_type') == 'wscp_casino_game'){
      $('html, body').animate({scrollTop: $(".casino-games").offset().top - 100}, 500);
    }
  }

  $(document).scroll(function(e) {
    if(window.pageYOffset > 300){
      $('.grid-parallax div').each(function(i, el) {
        $(el).css('transform', 'translateY(' + (window.pageYOffset * (i + 1) / 8) + 'px)');
      });
    }
  });

  if ( (typeof tribe_ev) !== 'undefined' && (typeof tribe_ev.events) !== 'undefined' ) {
    $( tribe_ev.events ).on( 'tribe_ev_ajaxSuccess', function() {
      trigger_window_resize();
    });
  }

  if ($('.mapplic-element-container').length > 0) {
    $('.mapplic-element-container').parent().addClass('full-width');
  }

  jQuery(".home #global-navigation").addClass('hover');

  setTimeout(function(){  
    jQuery(".home #global-navigation").removeClass('hover'); 
  }, 2000);

  function addHover(e){
      $("li.menu-item.dropdown.menu-item-has-children").removeClass("is_hovered");
      $(this).addClass("is_hovered");
  }

  $('.navbar').on('mouseleave', function(){
    setTimeout(function(){ $("li").removeClass("is_hovered"); }, 5);
  });


  $("#main-menu").hoverIntent( addHover, "li.menu-item.dropdown.menu-item-has-children" );

  function update_global_nav() {
    if ( $('#global-navigation').is(':visible') ) {
      
      var promotions_link = $('#global-navigation-promotions').attr('href');
      var map_link = $('#global-navigation-casinomap').attr('href');
      var gamefinder_link = $('#global-navigation-gamefinder').attr('href');
      
      if ( "" !== current_vertical ) {
        // Promotions link update
        switch(current_vertical) {
        case 'Stay':
          promotions_link += '?wscp_promotion_category=stay&s=&auto_redirect=true';
        
          break;
        case 'Entertainment':
          promotions_link += '?wscp_promotion_category=entertainment&s=&auto_redirect=true';
        
          break;
        case 'Gaming':
          promotions_link += '?wscp_promotion_category=gaming&s=&auto_redirect=true';
        
          break;
        case 'Dining':
          promotions_link += '?wscp_promotion_category=dining&s=&auto_redirect=true';
        
          break;
        case 'Amenities':
          promotions_link += '?wscp_promotion_category=amenities&s=&auto_redirect=true';
        
          break;
        case 'Meet':
          promotions_link += '';
        
          break;
        case 'Rewards':
          promotions_link += '?wscp_promotion_category=rewards&s=&auto_redirect=true';
        
          break;
        
        }
        
        $('#global-navigation-promotions').attr('href', promotions_link);
        
      }
            
      // Game Finder link update
      if ("" != global_vars.current_post_type && "wscp_casino_venue" == global_vars.current_post_type && "" !== global_vars.current_post_id) {
        gamefinder_link += '?wscp_casino_game_venue=' + global_vars.current_post_id + '&s=';

        $('#global-navigation-gamefinder').attr('href', gamefinder_link);
      }
      
    }
  }
  
  update_global_nav();

  // Updates the event venue search field
  var clickEventType = ( (document.ontouchstart !== null) ? 'click' : 'touchstart' );
  jQuery('.tribe-bar-filters .dropdown-menu .dropdown-item').on(clickEventType, function(ev) {
    jQuery('.tribe-bar-filters .dropdown-menu .dropdown-item').removeClass('active');
    jQuery(this).addClass('active');
    jQuery(this).parents(".dropdown").find('.dropdown-toggle').html( jQuery(this).text() );
    jQuery('input#tribe-bar-venue-field, input#tribe-bar-entertainment-venue-field, input#tribe-bar-casino-venue-field, input#tribe-bar-all-venue-field').val( jQuery(this).data('value') );
  });
  
  // mobile header scripts
  $(".js-header-mobile__menu").click(function() {
      if ($(".js-header-mobile-menu").hasClass("d-none")) {
          resetMobileMenu(true);
          $(".js-header-mobile__menu, .js-header-mobile__logo").addClass("active");
          $(".js-header-mobile-menu").removeClass("d-none");
          $(".js-header-mobile__menu-open").addClass("d-none");
          $(".js-header-mobile__menu-close").removeClass("d-none");
          $('body').addClass('mobile-menu-active');
      } else {
          resetMobileMenu(true);
      }
      
      var targetElement = $('.js-header-mobile-menu').length > 0 ? $('.js-header-mobile-menu')[0] : null;
      if (targetElement !== null && $(this).hasClass('active')) {
        bodyScrollLock.disableBodyScroll(targetElement);
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
  });​

  $(".js-header-mobile-menu #my-artesian-menu-mobile li.js-social-media-link a.nav-link").click( function(e) {
    e.preventDefault();
    var elem = $(e.target).toggleClass('active');
    $(".js-header-mobile-menu .social-links-section-mobile").toggleClass('d-none');
    if (!$(".js-header-mobile-menu .social-links-section-mobile").hasClass('d-none')) {
      $(".js-header-mobile-menu").scrollTop($(".js-header-mobile-menu").prop("scrollHeight"));
    }
  });


  //Mobile navigation modification scripts
  $(".global-nav-mobile").each(function(){
    if(window.location.href.indexOf("/gaming/casino-games/list/") != -1 || window.location.href.indexOf("/gaming/casino-games/category/") != -1) {
        $('#global-nav-game-finder-mobile').addClass('active');
    }
    if(window.location.href.indexOf("/promotions/list/") != -1 || window.location.href.indexOf("/promotions/category/") != -1) {
        $('#global-nav-promotions-mobile').addClass('active');
    }
    if(window.location.href.indexOf("/hotel-map") != -1 ) {
        $('#global-nav-hotel-map-mobile').addClass('active');
    }
  });
  
  $(".mobile-nav .active").each(function(){
      var $navItem = $(this);

      var $parentNavItem = $navItem.parents(".menu-item");

      if($parentNavItem.length > 0)
      {
          $parentNavItem.addClass("open");
      }
  });


  $(".js-header-mobile__search").click(function() {
      if ($(".js-header-mobile-search").hasClass("d-none")) {
        resetMobileMenu(true);
        $(this).addClass("active");
        $(".js-header-mobile-search").removeClass("d-none");
      } else {
        resetMobileMenu(true);
      }

      var targetElement = $('.js-header-mobile-search').length > 0 ? $('.js-header-mobile-search')[0] : null;
      if (targetElement !== null && $(this).hasClass('active')) {
        bodyScrollLock.disableBodyScroll(targetElement);
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
  });​

  $(".js-header-mobile__profile").click(function() {
      if ($(".js-header-mobile-profile").hasClass("d-none")) {
        $(".header-mobile__tab").removeClass("active");
        $('body').removeClass('mobile-menu-active');
        $(this).addClass("active");
        $(".js-header-mobile-search, .js-header-mobile-menu, .js-header-mobile__menu-close").addClass("d-none");
        $(".js-header-mobile-profile, .js-header-mobile__menu-open").removeClass("d-none");
      } else {
        resetMobileMenu(true);
      }
      
      var targetElement = $('.header-mobile__my-artesian-popover').length > 0 ? $('.header-mobile__my-artesian-popover')[0] : null;
      if (targetElement !== null && $(this).hasClass('active')) {
        bodyScrollLock.disableBodyScroll(targetElement);
      } else {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
  });​


  $(".js-header-mobile__subscribe").click(function() {
    $(this).toggleClass('active');
  });​
  
  function resetMobileMenu(click, target) {

    if ($('.js-header-mobile__book .popover').length > 0 && (click || target !== "booking")) {
      $('.header-mobile__menu-btn__book > a').popover('hide');
    }  

    if ($('.js-header-mobile__subscribe .popover').length > 0 && (click || target !== "subscribe")) {
      $('.header-mobile__menu-btn__subscribe > a').popover('hide');
    }  

    if ($('.header-mobile__my-artesian-popover').length > 0 && (click || target !== "my-artesian")) {
      $('.header-mobile__my-artesian-popover').popover('hide');
    }
    
    if (click) {
      $(".header-mobile__tab").removeClass("active");
      $(".js-header-mobile-search, .js-header-mobile-profile, .js-header-mobile-subscribe, .js-header-mobile-menu, .js-header-mobile__menu-close").addClass("d-none");
      $(".js-header-mobile__menu-open").removeClass("d-none");
      $("body").removeClass("mobile-menu-active");
      $("body").prop("style", "");
    }
    
  };

  window.resetMenu = resetMobileMenu;

  // clone desktop footer nav to mobile footer nav and style
  var footerLinks = "";
  var footerIcons = "";
  if ( $('.footer-menus-wrapper').length ) {
      footerLinks = $('.footer-menus-wrapper').clone();
  }

  if ( footerLinks.length > 0 ) {
      footerLinks.appendTo('.footer-mobile-links__nav');
      $('.footer-mobile-links__nav').find("*").removeAttr('id');
      $('.footer-mobile-links__section > .footer-mobile-links__nav > .footer-menus-wrapper').removeClass("d-flex justify-content-around col-lg-8");
      $('.footer-mobile-links__section > .footer-mobile-links__nav > .footer-menus-wrapper > .footer-menus > div > .menu').addClass("d-none");

      // clone more icons to mobile nav
      if ( $( ".footer-icons" ).length ) {
          footerIcons = $('.footer-icons').clone();
          footerIcons.appendTo('.js-footer-mobile-links__more-icons');
          $('.js-footer-mobile-links__more').appendTo('.footer-mobile-links__nav > .footer-menus-wrapper');
          $('.footer-mobile-links__nav > .footer-menus-wrapper > .footer-menus > .js-footer-mobile-links__more-icons > .footer-icons').removeClass("col-12").addClass("menu d-none");
      }

      //open close mobile footer menu
      $('.footer-mobile-links__section > .footer-mobile-links__nav > .footer-menus-wrapper > .footer-menus > .widget-title').click(function() {
          var selectedMenu = $(this).siblings().children(".menu");
          if (selectedMenu.hasClass("d-none")) {
              selectedMenu.removeClass("d-none");
          } else {
              selectedMenu.addClass("d-none");
          }
      });​
  }

  $(".carousel").on("touchstart", function(event){
      var xClick = event.originalEvent.touches[0].pageX;
      $(this).one("touchmove", function(event){
          var xMove = event.originalEvent.touches[0].pageX;
          if( Math.floor(xClick - xMove) > 5 ){
              $(this).carousel('next');
          }
          else if( Math.floor(xClick - xMove) < -5 ){
              $(this).carousel('prev');
          }
      });
      $(".carousel").on("touchend", function(){
              $(this).off("touchmove");
      });
  });

  function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  function debouncer(func, timeout) {
     var timeoutID, timeout = timeout || 15;
     return function () {
        var scope = this, args = arguments;
        clearTimeout(timeoutID);
        timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
        }, timeout);
     }
  }


  var mobile_gallery_carousel = $('.mobile-gallery-carousel'); 

  function initGallerySlider(){
   
    mobile_gallery_carousel.slick({
        centerMode: false,
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1200,
        fade: true,
        pauseOnHover: true,
        autoplay: true,
        appendArrows: 'footer',
        prevArrow: '<a href="##" class="slick-prev hidden-xs"></a>',
        nextArrow: '<a href="##" class="slick-next hidden-xs"></a>',
        slide: ".slick-carousel-item",
    });
     
  }

  initGallerySlider();


  var mobile_header_slider = $('.mobile-header-carousel'); 

  function initHeaderSlider(){
   
      mobile_header_slider.slick({
        centerMode: false,
        infinite: true,
        dots: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1200,
        pauseOnHover: false,
        autoplay: false,
        appendArrows: 'footer',
        prevArrow: '<a href="##" class="slick-prev hidden-xs"></a>',
        nextArrow: '<a href="##" class="slick-next hidden-xs"></a>',
        slide: ".slick-carousel-item",
    });
     
  }

  initHeaderSlider();

  var mq = window.matchMedia( "(min-width: 768px)" );

  function initSlider(){

    $('.grid_list--component').each( function( index, element ){

      var slides = $(this).find(".slick-carousel-item");

      // console.log();

      if(slides.length > 1) {

        if (mq.matches) {
            if($(this).hasClass('slick-initialized')){
                $(this).slick('unslick');
            }
        }
        else{
            if(!$(this).hasClass('slick-initialized')) {
                // console.log('slick start init');
                $(this).slick({
                    centerMode: true,
                    centerPadding: "20px",
                    infinite: true,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 700,
                    pauseOnHover: false,
                    autoplay: true,
                    appendArrows: 'footer',
                    prevArrow: '<a href="##" class="slick-prev hidden-xs"></a>',
                    nextArrow: '<a href="##" class="slick-next hidden-xs"></a>',
                    slide: ".slick-carousel-item",
                });
            }
        }
      }     
    });
  }

  initSlider();


   function initDiningGallerySlider(){

    $('.PrimaryGallery').each( function( index, element ){

      var slides = $(this).find(".slick-carousel-item");

      // console.log();

      if(slides.length > 1) {

        if (mq.matches) {
            if($(this).hasClass('slick-initialized')){
                $(this).slick('unslick');
            }
        }
        else{
            if(!$(this).hasClass('slick-initialized')) {
                // console.log('slick start init');
                $(this).slick({
                    centerMode: true,
                    centerPadding: "20px",
                    infinite: true,
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 700,
                    pauseOnHover: false,
                    autoplay: true,
                    appendArrows: 'footer',
                    prevArrow: '<a href="##" class="slick-prev hidden-xs"></a>',
                    nextArrow: '<a href="##" class="slick-next hidden-xs"></a>',
                    slide: ".slick-carousel-item",
                });
            }
        }
      }     
    });
  }

  initDiningGallerySlider();

  var testimonials_slider = $('.testimonials--component .testimonials-slider');

  function initTestimonialsSlider(){

      testimonials_slider.slick({
          centerMode: false,
          infinite: true,
          fade: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 1200,
          pauseOnHover: true,
          autoplay: true,
          appendArrows: 'footer',
          prevArrow: '<a href="##" class="slick-prev hidden-xs"></a>',
          nextArrow: '<a href="##" class="slick-next hidden-xs"></a>',
          slide: ".slick-carousel-item",
      });
  }

  initTestimonialsSlider();



  window.initSocialMediaSlider = function() {

      var socialmedia_slider = $('.social-cards-container');

      socialmedia_slider.slick({
          centerMode: false,
          infinite: true,
          fade: false,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2,
          speed: 1200,
          pauseOnHover: true,
          autoplay: true,
          appendArrows: 'footer',
          prevArrow: '<a href="##" class="slick-prev hidden-xs"></a>',
          nextArrow: '<a href="##" class="slick-next hidden-xs"></a>',
          slide: ".social-post",
          responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
      });
  }


  jQuery('.js-lazy-load').each(function() {
    var elem = jQuery(this);
    var do_replace = elem.data('replace');
    var is_app = getUrlParameter("app");
    var post_id = elem.data('post_id');

    jQuery.ajax({
      url: global_vars.ajax_url,
      type: 'post',
      data : {
        'action': elem.data('action'),
        'data_type': 'html',
        'tags': elem.data('tags'),
        'categories': elem.data('categories'),
        'max_items': elem.data('maxitems'),
        'exclude_ids': elem.data('excludeids'),
        'offers_partial': elem.data('offerspartial'),
        'current_page': elem.data('context'),
        'template': elem.data('template'),
        'minimize_ribbon': elem.data('minimizeribbon'),
        'current_vertical': current_vertical,
        'is_app': is_app,
        'post_id': post_id
      },
      success: function(response) {
        if (do_replace) {
          elem.replaceWith(response);
        } else {
          elem.html(response);          
        }

        trigger_callback(elem, response);
      }
    });
  });

  window.addEventListener('resize', 
    debouncer(function (event) {
      window.resetMenu(true);
      jQuery(".tabs-control--component:not('.prevent-collapse') .card.tab-pane.fade.active").removeClass("active show");
      jQuery(".tabs-control--component:not('.prevent-collapse') .nav-link").removeClass("active show");
      jQuery(".tabs-control--component:not('.prevent-collapse') .card.tab-pane.fade .collapse").removeClass("show");
      jQuery(".tabs-control--component:not('.prevent-collapse') .card.tab-pane.fade .card-header a").addClass("collapsed");
      initSlider();
      initDiningGallerySlider();
    } 
  ));

  jQuery(".tabs-control--component:not('.prevent-collapse') .nav-link").click(function(){
    var item = jQuery(this);
    var panel = jQuery('#' + this.hash.substr(1).toLowerCase());
    if(item.hasClass('active')){
      item.removeClass('active');
      panel.removeClass('active');     
      return false;
    }
  });

  jQuery('.tabs-control--component .card .collapse').on('show.bs.collapse', function () {
    jQuery(this).parent().addClass('active');
  });

  jQuery('.tabs-control--component .card .collapse').on('hidden.bs.collapse', function () {
    jQuery(this).parent().removeClass('active');
  });

  // Enables the Location 1 Business Hours popover
  $('#location-1-business-hours .hours-display').popover({
      html: true, 
      content: function() {
        return $("#mbhi-location-1-hours").html();
      },
      placement: 'bottom',
      offset: '0, 10px',
      trigger: 'hover',
      container: '#location-1-business-hours .bottom-section',
      title: 'Hours',
      // template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body" id="mbhi-location-1-wrapper"></div></div>'
  });

  // Enables the Location 2 Business Hours popover
  $('#location-2-business-hours .hours-display').popover({
      html: true, 
      content: function() {
        return $("#mbhi-location-2-hours").html();
      },
      placement: 'bottom',
      offset: '0, 10px',
      trigger: 'hover',
      container: '#location-2-business-hours .bottom-section',
      title: 'Hours',
      // template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body" id="mbhi-location-2-wrapper"></div></div>'
  });

  // Add the calendar date picker to the search form on the Promotions list page
  if ( $('#promotions-filter-form').length > 0 ) {
    $('#promotions-filter-form input[name="start_date"]').daterangepicker({
      singleDatePicker: true,
      // showDropdowns: true,
      // minYear: 1901,
      // maxYear: currentYear,
      autoUpdateInput: false
    }, function(start, end, label) {
      $('#promotions-filter-form input[name="start_date"]').val(start.format('MM-DD-YYYY'));
    });
  }

  // Submit the search form after an icon click on the 404 page
  if ( $('#error-404-wrapper').length > 0 ) {

    $('#error-404-wrapper form#searchform').submit(function(e) {
      if ($('#error-404-wrapper form#searchform input').val().length < 1)
        e.preventDefault()
    });

    $("span.sb-icon-search").click(function() {
      $("#error-404-wrapper form#searchform").submit();
    });
  }



  // Miniaturize the header during a scroll down the page on desktop displays only
  if ( $('#wrapper-navbar').is(':visible') ) {    
    window.addEventListener('scroll', function() {

      if(!jQuery("body").hasClass("collapsed") && !jQuery(".header").hasClass("has-map")){
        if(jQuery(window).scrollTop() > 100) {
          jQuery("body").addClass("collapsed")
        }

        if(jQuery(window).scrollTop() <= 90) {
          if(jQuery(".sticky-standard-content-container").length > 0 && jQuery(".sidebar-column").length > 0) {

            var content_column_height = jQuery(".sticky-standard-content-container").height();
            var sidebar_column_height = jQuery(".sidebar-column").height();

            var height_ratio =content_column_height/sidebar_column_height;

            if(height_ratio < 0.65){
              jQuery(".sticky-standard-content-container").addClass("sticky");
            }

            //console.log(height_ratio);

          }
        }

      } else {

        if(jQuery(window).scrollTop() <= 100) {
          jQuery("body").removeClass("collapsed")
        }

      }

    });
  }

});


